const investExpertiseAssetsTable = {
	group: {
		tag: 'invest.expertise.assets.table.group',
		fr: 'Groupe',
		en: 'Group',
	},
	investor: {
		tag: 'invest.expertise.assets.table.investor',
		fr: 'Canton',
		en: 'Sub-portfolio',
	},
	fund: {
		tag: 'invest.expertise.assets.table.fund',
		fr: 'Fonds',
		en: 'Fund',
	},
	asset: {
		tag: 'invest.expertise.assets.table.asset',
		fr: 'Actif',
		en: 'Asset',
	},
	entreprise: {
		tag: 'invest.expertise.assets.table.entreprise',
		fr: 'Entreprise',
		en: 'Entreprise',
	},
	country: {
		tag: 'invest.expertise.assets.table.country',
		fr: 'Pays',
		en: 'Country',
	},
	sector: {
		tag: 'invest.expertise.assets.table.sector',
		fr: 'Industrie',
		en: 'Industry',
	},
	asset_currency: {
		tag: 'invest.expertise.assets.table.asset_currency',
		fr: 'Devise (actif)',
		en: 'Asset currency',
	},
	asset_status: {
		tag: 'invest.expertise.assets.table.asset_status',
		fr: 'Statut',
		en: 'Asset status',
	},
	investment_year: {
		tag: 'invest.expertise.assets.table.investment_year',
		fr: "Année d'investissement",
		en: 'Investment year',
	},
	invested_capital: {
		tag: 'invest.expertise.assets.table.invested_capital',
		fr: 'Montant investi',
		en: 'Contributed capital',
	},
	distributions: {
		tag: 'invest.expertise.assets.table.distributions',
		fr: 'Distributions',
		en: 'Distributions',
	},

	fmv: {
		tag: 'invest.expertise.assets.table.fmv',
		fr: 'FMV',
		en: 'FMV',
	},
	fmv_tooltip: {
		tag: 'invest.expertise.assets.table.fmv_tooltip',
		fr: 'FMV: Fair Market Value. Mis à jour à chaque rapport périodique ou en cas de modification capitalistique.',
		en: 'FMV : Fair Market Value. Updated at each periodical report or in case of capitalistic change.',
	},
	multiple: {
		tag: 'invest.expertise.assets.table.multiple',
		fr: 'Multiple (net)',
		en: 'Multiple (net)',
	},
};

export default investExpertiseAssetsTable;
